/**
 * Stable CSS class names for E2E — User order product details (billing, cargo status history, cross shipment list, not delivered reasons).
 */

export const UBILL = {
    root: 'order-detail-user-billing-information__root',
    eInvoiceCard: 'order-detail-user-billing-information__e-invoice-card',
    eInvoiceContent: 'order-detail-user-billing-information__e-invoice-content',
    eInvoiceTitle: 'order-detail-user-billing-information__e-invoice-title',
    eInvoiceDocRow: 'order-detail-user-billing-information__e-invoice-doc-row',
    eInvoiceDocButton: 'order-detail-user-billing-information-input--button-e-invoice-doc',
    eInvoiceCopyWrap: 'order-detail-user-billing-information__e-invoice-copy-wrap',
    eInvoiceDateRow: 'order-detail-user-billing-information__e-invoice-date-row',
    waybillCard: 'order-detail-user-billing-information__waybill-card',
    waybillContent: 'order-detail-user-billing-information__waybill-content',
    waybillTitle: 'order-detail-user-billing-information__waybill-title',
    waybillDocRow: 'order-detail-user-billing-information__waybill-doc-row',
    waybillDocButton: 'order-detail-user-billing-information-input--button-waybill-doc',
    waybillCopyWrap: 'order-detail-user-billing-information__waybill-copy-wrap',
    waybillDateRow: 'order-detail-user-billing-information__waybill-date-row',
} as const;

export const UCSH = {
    loadingWrap: 'order-detail-user-cargo-status-history__loading-wrap',
    loadingInner: 'order-detail-user-cargo-status-history__loading-inner',
    root: 'order-detail-user-cargo-status-history__root',
    table: 'order-detail-user-cargo-status-history__table',
    headRow: 'order-detail-user-cargo-status-history__head-row',
    headCellDate: 'order-detail-user-cargo-status-history__head-cell-date',
    headCellUser: 'order-detail-user-cargo-status-history__head-cell-user',
    headCellUserType: 'order-detail-user-cargo-status-history__head-cell-user-type',
    headCellStatus: 'order-detail-user-cargo-status-history__head-cell-status',
    headCellDescription: 'order-detail-user-cargo-status-history__head-cell-description',
    bodyRow: 'order-detail-user-cargo-status-history__body-row',
    bodyCellDate: 'order-detail-user-cargo-status-history__body-cell-date',
    bodyCellUser: 'order-detail-user-cargo-status-history__body-cell-user',
    bodyCellUserType: 'order-detail-user-cargo-status-history__body-cell-user-type',
    bodyCellStatus: 'order-detail-user-cargo-status-history__body-cell-status',
    bodyCellDescription: 'order-detail-user-cargo-status-history__body-cell-description',
    footerRow: 'order-detail-user-cargo-status-history__footer-row',
    footerTotal: 'order-detail-user-cargo-status-history__footer-total',
    emptyWrap: 'order-detail-user-cargo-status-history__empty-wrap',
    emptyIcon: 'order-detail-user-cargo-status-history__empty-icon',
    emptyTitle: 'order-detail-user-cargo-status-history__empty-title',
} as const;

export const UCL = {
    rootCard: 'order-detail-user-cross-shipment-list__card',
    content: 'order-detail-user-cross-shipment-list__content',
    tableContainer: 'order-detail-user-cross-shipment-list__table-container',
    table: 'order-detail-user-cross-shipment-list__table',
    headRow: 'order-detail-user-cross-shipment-list__head-row',
    headCellId: 'order-detail-user-cross-shipment-list__head-cell-id',
    headCellNo: 'order-detail-user-cross-shipment-list__head-cell-no',
    bodyRow: 'order-detail-user-cross-shipment-list__row',
    bodyCellId: 'order-detail-user-cross-shipment-list__cell-id',
    bodyCellNo: 'order-detail-user-cross-shipment-list__cell-no',
    loadingGrid: 'order-detail-user-cross-shipment-list__loading-grid',
    loadingInner: 'order-detail-user-cross-shipment-list__loading-inner',
    emptyWrap: 'order-detail-user-cross-shipment-list__empty-wrap',
    emptyTitle: 'order-detail-user-cross-shipment-list__empty-title',
} as const;

export const UNDR = {
    chip: 'order-detail-user-not-delivered-reasons-input--chip-trigger',
    dialogPaper: 'order-detail-user-not-delivered-reasons__dialog-paper',
    dialogTitle: 'order-detail-user-not-delivered-reasons__dialog-title',
    dialogTitleLeft: 'order-detail-user-not-delivered-reasons__dialog-title-left',
    dialogTitleRight: 'order-detail-user-not-delivered-reasons__dialog-title-right',
    dialogCloseButton: 'order-detail-user-not-delivered-reasons-input--button-dialog-close',
    dialogContent: 'order-detail-user-not-delivered-reasons__dialog-content',
    table: 'order-detail-user-not-delivered-reasons__table',
    headRow: 'order-detail-user-not-delivered-reasons__head-row',
    headCellDate: 'order-detail-user-not-delivered-reasons__head-cell-date',
    headCellDescription: 'order-detail-user-not-delivered-reasons__head-cell-description',
    bodyRow: 'order-detail-user-not-delivered-reasons__row',
    bodyCellDate: 'order-detail-user-not-delivered-reasons__cell-date',
    bodyCellDescription: 'order-detail-user-not-delivered-reasons__cell-description',
} as const;

export const uopdCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

export const UOAH = {
    root: 'order-detail-user-accordion-header',
    shipmentsGrid: 'order-detail-user-accordion-header__shipments-grid',
    shippingIdWrap: 'order-detail-user-accordion-header__shipping-id-wrap',
    shippingIdCopiedBadge: 'order-detail-user-accordion-header__shipping-id-copied-badge',
    shippingIdLink: 'order-detail-user-accordion-header-input--link-shipping-id',
    shipmentNoWrap: 'order-detail-user-accordion-header__shipment-no-wrap',
    shipmentNoCopiedBadge: 'order-detail-user-accordion-header__shipment-no-copied-badge',
    shipmentNoLink: 'order-detail-user-accordion-header-input--link-shipment-no',
    shipmentTypeChip: 'order-detail-user-accordion-header__shipment-type-chip',
    warehouseNameWrap: 'order-detail-user-accordion-header__warehouse-name-wrap',
    warehouseNameLink: 'order-detail-user-accordion-header-input--link-warehouse-name',
    warehouseNameCopiedBadge: 'order-detail-user-accordion-header__warehouse-name-copied-badge',
    cargoTrackingLink: 'order-detail-user-accordion-header-input--link-cargo-tracking',
    cargoTrackingChip: 'order-detail-user-accordion-header__cargo-tracking-chip',
    cargoAgreementChip: 'order-detail-user-accordion-header__cargo-agreement-chip',
    shipmentStatusLink: 'order-detail-user-accordion-header-input--link-shipment-status',
    shipmentStatusChip: 'order-detail-user-accordion-header__shipment-status-chip',
    reShipActionWrap: 'order-detail-user-accordion-header__re-ship-action-wrap',
    reShipIconButton: 'order-detail-user-accordion-header-input--button-reship',
    reShipLoading: 'order-detail-user-accordion-header__reship-loading',
    sharedShipmentCodeClickWrap: 'order-detail-user-accordion-header__shared-shipment-code-click-wrap',
    sharedShipmentCodeClickArea: 'order-detail-user-accordion-header-input--button-shared-shipment-code',
    consolidatedOrderLink: 'order-detail-user-accordion-header-input--link-consolidated-order',
    deliveryTypeChip: 'order-detail-user-accordion-header__delivery-type-chip',
    photoAnimationGrid: 'order-detail-user-accordion-header__photo-animation-grid',
    outofStockGrid: 'order-detail-user-accordion-header__outof-stock-grid',
    outofStockMoreBubble: 'order-detail-user-accordion-header__outof-stock-more',
    mergedShipmentCode: 'order-detail-user-accordion-header__merged-shipment-code',
} as const;

export const UOPT = {
    root: 'order-detail-user-order-product-table',
    dialog: 'order-detail-user-order-product-table__dialog',
    dialogContent: 'order-detail-user-order-product-table__dialog-content',
    dialogImage: 'order-detail-user-order-product-table__dialog-image',
    card: 'order-detail-user-order-product-table__card',
    cardContent: 'order-detail-user-order-product-table__card-content',
    tableContainer: 'order-detail-user-order-product-table__table-container',
    table: 'order-detail-user-order-product-table__table',
    tableHeadRow: 'order-detail-user-order-product-table__head-row',
    tableBodyRow: 'order-detail-user-order-product-table__body-row',
    photoCell: 'order-detail-user-order-product-table__cell-photo',
    productCell: 'order-detail-user-order-product-table__cell-product',
    optionIdCell: 'order-detail-user-order-product-table__cell-option-id',
    brandRowText: 'order-detail-user-order-product-table__brand',
    barcodeCopy: 'order-detail-user-order-product-table-input--button-copy-barcode',
    ozellikKodCopy: 'order-detail-user-order-product-table-input--button-copy-option-codes',
    optionIdCopy: 'order-detail-user-order-product-table-input--button-copy-option-id',
    colorSizeCopy: 'order-detail-user-order-product-table-input--button-copy-color-size',
    openImageIconWrap: 'order-detail-user-order-product-table-input--button-open-product-image',
    openImageIcon: 'order-detail-user-order-product-table__open-image-icon',
    returnMessageWrap: 'order-detail-user-order-product-table__return-message-wrap',
    campaignDiscountWrap: 'order-detail-user-order-product-table__campaign-discount-wrap',
    campaignList: 'order-detail-user-order-product-table__campaign-list',
    campaignItem: 'order-detail-user-order-product-table__campaign-item',
    campaignItemId: 'order-detail-user-order-product-table__campaign-item-id',
    campaignItemName: 'order-detail-user-order-product-table__campaign-item-name',
    campaignItemAmount: 'order-detail-user-order-product-table__campaign-item-amount',
    returnErrorWrap: 'order-detail-user-order-product-table__return-error-wrap',
    mainOrderLink: 'order-detail-user-order-product-table-input--link-main-order',
    productOptionLink: 'order-detail-user-order-product-table-input--link-product-option',
} as const;

export const UOSP = {
    root: 'order-detail-user-shipping-price-infos',
    discountWrap: 'order-detail-user-shipping-price-infos__discount-wrap',
    discountAlert: 'order-detail-user-shipping-price-infos__discount-alert',
    discountInner: 'order-detail-user-shipping-price-infos__discount-inner',
    tableWrap: 'order-detail-user-shipping-price-infos__table-wrap',
    table: 'order-detail-user-shipping-price-infos__table',
    tableHeadRow: 'order-detail-user-shipping-price-infos__head-row',
    cellLabel: 'order-detail-user-shipping-price-infos__cell-label',
    cellValue: 'order-detail-user-shipping-price-infos__cell-value',
} as const;

export const UOTOST = {
    root: 'order-detail-user-out-of-stock-table',
    dialog: 'order-detail-user-out-of-stock-table__dialog',
    dialogContent: 'order-detail-user-out-of-stock-table__dialog-content',
    tableContainer: 'order-detail-user-out-of-stock-table__table-container',
    table: 'order-detail-user-out-of-stock-table__table',
    tableHeadRow: 'order-detail-user-out-of-stock-table__head-row',
    bodyRow: 'order-detail-user-out-of-stock-table__body-row',
    photoCell: 'order-detail-user-out-of-stock-table__cell-photo',
    barcodeCell: 'order-detail-user-out-of-stock-table__cell-barcode',
    productLink: 'order-detail-user-out-of-stock-table-input--link-product-option',
    openImageIconWrap: 'order-detail-user-out-of-stock-table-input--button-open-product-image',
} as const;

export const UOF = {
    root: 'order-detail-user-show-product-on-fraud-control',
    table: 'order-detail-user-show-product-on-fraud-control__table',
    tableHeadRow: 'order-detail-user-show-product-on-fraud-control__head-row',
    tableBodyRow: 'order-detail-user-show-product-on-fraud-control__body-row',
    photoCell: 'order-detail-user-show-product-on-fraud-control__cell-photo',
    barcodeCell: 'order-detail-user-show-product-on-fraud-control__cell-barcode',
    optionLink: 'order-detail-user-show-product-on-fraud-control-input--link-product-option',
} as const;

export const UOPD_DETAIL = {
    root: 'order-detail-user-order-product-detail',
    statusDialog: 'order-detail-user-order-product-detail__status-dialog',
    statusDialogContent: 'order-detail-user-order-product-detail__status-dialog-content',
    statusDialogPaper: 'order-detail-user-order-product-detail__status-dialog-paper',
    shipmentAccordion: 'order-detail-user-order-product-detail__shipment-accordion',
    shipmentSummary: 'order-detail-user-order-product-detail__shipment-summary',
    shipmentDetails: 'order-detail-user-order-product-detail__shipment-details',
    bottomNavigation: 'order-detail-user-order-product-detail__bottom-navigation',
    bottomNavAction: 'order-detail-user-order-product-detail__bottom-navigation-action',
    bottomNavActionProductInfos: 'order-detail-user-order-product-detail__bottom-nav-action-product-infos',
    bottomNavActionCargoInfos: 'order-detail-user-order-product-detail__bottom-nav-action-cargo-infos',
    bottomNavActionShipmentStatusInfos: 'order-detail-user-order-product-detail__bottom-nav-action-shipment-status-infos',
    bottomNavActionCrossShipment: 'order-detail-user-order-product-detail__bottom-nav-action-cross-shipment',
    bottomNavActionBillingInformation: 'order-detail-user-order-product-detail__bottom-nav-action-billing-information',
    outOfStockSection: 'order-detail-user-order-product-detail__out-of-stock-section',
    outOfStockAccordion: 'order-detail-user-order-product-detail__out-of-stock-accordion',
    outOfStockSummary: 'order-detail-user-order-product-detail__out-of-stock-summary',
    goToShipmentButton: 'order-detail-user-order-product-detail__out-of-stock-go-to-shipment-button',
    goToShipmentIcon: 'order-detail-user-order-product-detail__out-of-stock-go-to-shipment-icon',
    fraudControlWrapper: 'order-detail-user-order-product-detail__fraud-control-wrapper',
    paymentAccordion: 'order-detail-user-order-product-detail__payment-accordion',
    paymentSummary: 'order-detail-user-order-product-detail__payment-summary',
} as const;

